<header class="topbar">
  <div class="topbar-left">
    <button mat-icon-button type="button" class="menu-btn" (click)="menuToggle.emit()" aria-label="Toggle menu">
      <mat-icon>menu</mat-icon>
    </button>
    <a class="brand" [routerLink]="['/dashboard']">
      <mat-icon>monitor_heart</mat-icon>
      <span class="brand-name">HospitalEase</span>
    </a>
  </div>

  <div class="topbar-center">
    <app-breadcrumb></app-breadcrumb>
  </div>

  <div class="topbar-right">
    <div class="theme-selector">
      <mat-icon class="theme-icon">palette</mat-icon>
      <select 
        id="theme-select" 
        [value]="activeTheme" 
        (change)="onThemeSelect($any($event.target).value)"
        aria-label="Select theme"
        class="theme-select"
      >
        <option value="theme-blue">Hospital Blue</option>
        <option value="theme-green">Hospital Green</option>
        <option value="theme-hospital">Hospital</option>
        <option value="theme-dark">Hospital Dark</option>
      </select>
    </div>

    <span class="topbar-date">
      <mat-icon class="date-icon">calendar_today</mat-icon>
      {{ currentDate | date: 'EEE, d MMM y' }}
    </span>

    <app-user-profile-menu
      [userName]="userName"
      [userRole]="userRole"
      [userAvatar]="userAvatar"
      (profileClick)="onProfileClick()"
      (settingsClick)="onSettingsClick()"
      (logout)="onLogout()"
    ></app-user-profile-menu>
  </div>
</header>
